import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import FeaturedStylistCard from './Cards/FeaturedStylistCard'
import SliderLeftBlackIcon from '../../assets/imgs/slider-left-icon-black.png'
import SliderRightBlackIcon from '../../assets/imgs/slider-right-icon-black.png'
import axios from 'axios'
import { getAllData, getDataById } from '../../apis/generalApis'

const FeaturedStylist = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const featuredServices = useRef(null)
  const scroll = (scrollValue) => {
    featuredServices.current.scrollLeft += scrollValue
  }
  const [featuredStylists, setFeaturedStylists] = useState([])
  const [favouriteStylists, setFavouriteStylists] = React.useState([])

  useEffect(() => {
    getFeaturedStylists()
  }, [])

  const getFeaturedStylists = async () => {
    let result = await getAllData('featured-stylists')
    if (result?.success === true && result?.data != null) {
      setFeaturedStylists(result?.data)
    }
  }

  const getFavouriteStylists = async () => {
    try {
      let result = await getDataById('show-favorite-stylists', {
        user_id: user?.id,
      })
      if (result?.success === true) {
        setFavouriteStylists(result?.data?.stylist)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="featured-stylist text-center">
      <h1 className="section-heading" style={{fontSize: '48px'}}>Featured Stylist</h1>
      <h1 style={{fontSize: '30px'}}>Bringing in creatives from all over the globe</h1>
      <div className="position-relative">
        <img
          src={SliderLeftBlackIcon}
          alt="Slider Icon"
          className="service-slider-icon client pointer left"
          onClick={() => scroll(-500)}
        />
        <img
          src={SliderRightBlackIcon}
          alt="Slider Icon"
          className="service-slider-icon client pointer"
          onClick={() => scroll(500)}
        />
        <div
          className="row flex-nowrap overflow-auto m-0 mt-5 position-relative pb-3"
          style={{ paddingLeft: '4rem', scrollBehavior: 'smooth' }}
          ref={featuredServices}
        >
          {featuredStylists?.length > 0 &&
            featuredStylists?.map(
              (stylist, index) =>
                index < 15 && (
                  <div
                    className="col-8 col-sm-6 col-md-5 col-lg-4"
                    key={stylist?.id}
                  >
                    <FeaturedStylistCard
                    stylist={stylist}
                    action={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? 'remove-favourite'
                        : 'add-favourite'
                    }
                    isFavourite={
                      favouriteStylists?.find((el) => el?.id === stylist?.id)
                        ? true
                        : false
                    }
                    getFavouriteStylists={getFavouriteStylists}
                    getFeaturedStylists={getFeaturedStylists}
                  />
                  </div>
                ),
            )}
        </div>
      </div>
    </div>
  )
}

export default FeaturedStylist
